module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "table-responsive"
  }, [_c('b-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('b-table', {
    attrs: {
      "show-empty": "",
      "striped": "",
      "stacked": "md",
      "bordered": _vm.table.bordered,
      "items": _vm.propsHistorico,
      "fields": _vm.table.fields,
      "filter": _vm.table.filter,
      "current-page": _vm.table.currentPage,
      "per-page": _vm.table.perPage,
      "sort-by": _vm.table.sortBy,
      "sort-desc": _vm.table.sortDesc,
      "empty-text": "Nenhum registro encontrado"
    },
    on: {
      "update:sortBy": function($event) {
        return _vm.$set(_vm.table, "sortBy", $event)
      },
      "update:sort-by": function($event) {
        return _vm.$set(_vm.table, "sortBy", $event)
      },
      "update:sortDesc": function($event) {
        return _vm.$set(_vm.table, "sortDesc", $event)
      },
      "update:sort-desc": function($event) {
        return _vm.$set(_vm.table, "sortDesc", $event)
      }
    },
    scopedSlots: _vm._u([{
      key: "inicio",
      fn: function(row) {
        return [(row.item.data_edicao) ? _c('span', [_vm._v(_vm._s(_vm._f("moment")(row.item.data_edicao, "DD/MM/YYYY HH:mm")))]) : _c('span', [_vm._v(_vm._s(_vm._f("moment")(row.value, "DD/MM/YYYY HH:mm")))])]
      }
    }, {
      key: "termino",
      fn: function(row) {
        return [_vm._v(_vm._s(_vm._f("moment")(row.value, "DD/MM/YYYY HH:mm")))]
      }
    }, {
      key: "nome",
      fn: function(row) {
        return [(row.value === 'DEVOLVE_ATRIBUICAO') ? _c('span', [_vm._v(_vm._s(_vm.dePara(row.item.etapa_anterior)))]) : _vm._e(), _vm._v(" "), (row.value === 'REVISAO' || row.value === 'Revisão') ? _c('span', [_vm._v("Revisão")]) : _vm._e(), _vm._v(" "), (row.value === 'TAREFA_REATIVADA') ? _c('span', [_vm._v("Tarefa Reativada")]) : _vm._e(), _vm._v(" "), (row.value === 'CANCELADO') ? _c('span', [_vm._v("Processo Cancelado")]) : _vm._e(), _vm._v(" "), (row.value === 'TAREFA_ASSUMIDA') ? _c('span', [_vm._v(_vm._s(_vm.dePara(row.item.etapa_anterior)))]) : _vm._e(), _vm._v(" "), (row.value !== 'TAREFA_ASSUMIDA' && row.value !== 'DEVOLVE_ATRIBUICAO') ? _c('span', [_vm._v(_vm._s(_vm.dePara(row.value)))]) : _vm._e(), _vm._v(" "), (row.value == 'ANALISE_FINANCEIRA' && row.value == 'Análise Financeira') ? _c('span', [_vm._v("Acerto Contábil")]) : _vm._e()]
      }
    }, {
      key: "proxima_etapa",
      fn: function(row) {
        return [(!_vm._.isNull(row.item.termino)) ? _c('span', [(row.item.nome === 'TAREFA_ASSUMIDA') ? _c('span', [_vm._v(" Tarefa Assumida")]) : _vm._e(), _vm._v(" "), (row.item.nome === 'DEVOLVE_ATRIBUICAO') ? _c('span', [_vm._v(" Devolvido para a Caixa")]) : _vm._e(), _vm._v(" "), (row.item.nome === 'Reabilita') ? _c('span', [_vm._v(" Tarefa Reabilitada")]) : _vm._e(), _vm._v(" "), (_vm._.includes(['ANALISE', 'Análise'], row.item.proxima_etapa) && _vm._.includes(['AUTORIZACAO', 'Autorização', 'ANALISE_TRIBUTARIA', 'Análise Tributária', 'ANALISE_FINANCEIRA', 'LIQUIDACAO_FINANCEIRA', 'Liquidação'], row.item.nome)) ? _c('span', [_vm._v(" Devolvido para Análise")]) : _vm._e(), _vm._v(" "), (row.item.proxima_etapa === 'REVISAO' || row.item.proxima_etapa === 'Revisão') ? _c('span', [_vm._v(" Enviado para Revisão da Entidade")]) : _vm._e(), _vm._v(" "), (row.item.proxima_etapa === 'AUTORIZACAO' || row.item.proxima_etapa === 'Autorização') ? _c('span', [_vm._v(" Enviado para Autorização")]) : _vm._e(), _vm._v(" "), (row.item.proxima_etapa === 'ANALISE_FINANCEIRA' || row.item.proxima_etapa === 'Análise Financeira') ? _c('span', [_vm._v(" Enviado para Acerto Contábil")]) : _vm._e(), _vm._v(" "), (row.item.proxima_etapa === 'ANALISE_TRIBUTARIA' || row.item.proxima_etapa === 'Análise Tributária') ? _c('span', [_vm._v(" Enviado para Análise Tributária")]) : _vm._e(), _vm._v(" "), (row.item.proxima_etapa === 'LIQUIDACAO_FINANCEIRA' || row.item.proxima_etapa === 'Liquidação') ? _c('span', [_vm._v(" Enviado para Liquidação")]) : _vm._e(), _vm._v(" "), (row.item.proxima_etapa === 'CONCLUSAO' || row.item.proxima_etapa === 'Conclusão') ? _c('span', [_vm._v(" " + _vm._s(_vm.meuStatus))]) : _vm._e(), _vm._v(" "), (row.item.nome === 'Solicitação') ? _c('span', [_vm._v(" Enviado para Análise")]) : _vm._e(), _vm._v(" "), (row.item.nome === 'SOLICITACAO') ? _c('span', [_vm._v(" Enviado para Análise")]) : _vm._e(), _vm._v(" "), (row.item.nome === 'Revisão' || row.item.nome === 'REVISAO') ? _c('span', [_vm._v(" Enviado para Análise")]) : _vm._e(), _vm._v(" "), (row.item.nome === 'TAREFA_REATIVADA') ? _c('span', [_vm._v(" Enviado para Análise")]) : _vm._e()]) : _vm._e()]
      }
    }, {
      key: "usuario.ds_tipo_usuario",
      fn: function(row) {
        return [(row.value === 'ENTIDADE') ? _c('span', [_vm._v("Parceiro")]) : _vm._e(), _vm._v(" "), (row.value === 'FUNDACAO') ? _c('span', [_vm._v("FBB")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('b-row', [_c('b-col', {
    staticClass: "my-1",
    attrs: {
      "md": "6",
      "right": ""
    }
  }, [_c('b-pagination', {
    staticClass: "my-3",
    attrs: {
      "total-rows": _vm.table.totalRows,
      "per-page": _vm.table.perPage
    },
    model: {
      value: (_vm.table.currentPage),
      callback: function($$v) {
        _vm.$set(_vm.table, "currentPage", $$v)
      },
      expression: "table.currentPage"
    }
  })], 1)], 1)], 1)], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2e39fc18!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/solicitacoes/modulos/historicoSolicitacaoPagamento.vue
// module id = 1848
// module chunks = 2